export const enMeritocracyParamatersPageTranslation = {
  meritocracyParameters: {
    title: 'Configurations',
    description:
      'Decide the weights and criteria that will define how the system recommends changes to your employees’ compensation.',
    tabs: {
      performanceCriteriaParameter: {
        title: 'Analysis Criteria',
        description:
          'Decide the weights and criteria that will define how the system recommends changes to your employees’ compensation.',
        content: {
          weights: {
            title: 'Weights',
            tables: {
              weights: {
                headers: {
                  crietria: 'Criteria', // corrected spelling from crietria to criteria
                },
                bottom: {
                  sum: 'Sum',
                },
              },
            },
            actions: {
              save: 'Save weights',
            },
          },
          criterias: {
            title: 'Criteria',
            tables: {
              common: {
                headers: {
                  ref: 'Ref.',
                  performance: 'Performance',
                },
                bottom: {
                  max: 'Max',
                  target: 'Target',
                  min: 'Min',
                },
              },
              performance_competencies: {
                title: 'Competencies',
              },
              performance_individual: {
                title: 'Individual Target Assessment',
              },
              performance_final: {
                title: 'Final Performance',
              },
              performance_potencial: {
                title: 'Potential',
              },
            },
            actions: {
              save: 'Save criteria',
            },
          },
        },
      },
      politicalParameter: {
        title: 'Meritocracy Policies',
      },
    },
  },
};
